import { render, staticRenderFns } from "./AddLayerButton.vue?vue&type=template&id=e77ef97a&scoped=true&"
var script = {}
import style0 from "./AddLayerButton.vue?vue&type=style&index=0&id=e77ef97a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77ef97a",
  null
  
)

export default component.exports